import dispatcher from "../dispatcher";
import { productConstant } from "../constants/constants";
import rq from "../components/utility/rq.js";

export function createProduct(product) {
    rq.post("/api/v1/products", product).then((data) => {
        product.productId = data[0].lastId;
        dispatcher.dispatch({ type: productConstant.PRODUCT_CREATED, product });
    }).catch((data) => {
        dispatcher.dispatch({ type: productConstant.PRODUCT_CREATION_FAILED, msg: `creating product ${product.productName} failed ! ${data.responseText}` });
    });
}

export function fetchAllProduct() {
    rq.getJsonData("/api/v1/products").then((data) => {
        dispatcher.dispatch({ type: productConstant.FETCHED_ALL_PRODUCTS, data });
    }).catch((data) => {
        dispatcher.dispatch({ type: productConstant.PRODUCTS_FETCH_FAILED, msg: `Fetching product failed ! ${data.responseText}` });
    });

}



// WEBPACK FOOTER //
// ./src/jsx/actions/product-action.jsx